import {createAsyncThunk} from '@reduxjs/toolkit';

import {API_ENDPOINTS} from '../constants';
import type {ConfigsResponse, FetchOrdersArgs, OrdersResponse} from '../types';

import {request} from '../shared/utils';
import {addAuthParams} from '@/features/auth/helpers';

export const fetchConfig = createAsyncThunk<ConfigsResponse>(
  'global/config/fetch',
  () => request<ConfigsResponse>({uri: API_ENDPOINTS.CONFIGS, method: 'GET'})
);

export const fetchOrders = createAsyncThunk<OrdersResponse, FetchOrdersArgs>(
  'orders/fetch',
  async ({urlParams, signal}) => {
    const modifiedUrlParams = addAuthParams(urlParams);

    return await request<OrdersResponse>({
      uri: `${API_ENDPOINTS.ORDERS}?${modifiedUrlParams}`,
      method: 'GET',
      signal,
    });
  }
);
